import React from "react";

// region Languages
import useTranslation from "@languages/useTranslation";
// endregion Languages

import { LegacyMigrationMessages } from "./languages/interfaces";
import * as Styled from "./styles";
import { TStep } from "./useLegacyMigration";

/** The three steps the operator sees. */
const STEP_LABELS = [
  LegacyMigrationMessages.legacyMigrationStepCustomer,
  LegacyMigrationMessages.legacyMigrationStepReview,
  LegacyMigrationMessages.legacyMigrationStepResult
];

/**
 * Where each state of the assistant falls among them; "done" is past the last
 * one. Reading stays on "Cliente": the review is reached only once the users
 * are read, and a failed read goes back to the customer list.
 */
const STEP_INDEX: Record<TStep, number> = {
  customer: 0,
  reading: 0,
  review: 1,
  migrating: 2,
  done: 3
};

interface IStepperProps {
  current: TStep;
}

/** Shows where the operator is in the migration of one customer. */
const Stepper: React.FC<IStepperProps> = ({ current }) => {

  // region Hooks
  const { t } = useTranslation();
  // endregion Hooks

  const currentIndex = STEP_INDEX[current];

  return (
    <Styled.Steps>
      {STEP_LABELS.map((label, index) => (
        <Styled.Step
          key={label}
          $state={(() => {
            if (index < currentIndex) return "done";

            return index === currentIndex ? "current" : "next";
          })()}
        >
          <span>{index < currentIndex ? "✓" : index + 1}</span>
          {t(label)}
        </Styled.Step>
      ))}
    </Styled.Steps>
  );
};

export default Stepper;
